import { createCRUDHook } from './createCRUDHook';
import { LeadSourceDto } from 'utils/models';
import { CRM_LEADSOURCE } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<LeadSourceDto>({
  entityName: 'LeadSource',
  endpoint: CRM_LEADSOURCE,
});

export const LeadSourceContext = Context;
export const useLeadSourceManager = useManager;
export const useLeadSource = useConsumer;
